import React, { useState, useEffect } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { GeneralContainer, CategoryContainer } from "./TemplateList.styled";
import { ALL_SURVEY_TEMPLATE } from "../../GraphQL/Queries";
import { ReactComponent as OpenModal } from "../../assets/svg/open-modal.svg";
import { useLazyQuery } from "@apollo/client";
import ModalLoader from "../ModalLoader/ModalLoader";

const TemplateList = ({ handleOpen, renderList }) => {
  const [templates, setTemplates] = useState([]);
  const [runQueryGetTemplates, { loading: loadingTemplates }] = useLazyQuery(
    ALL_SURVEY_TEMPLATE,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (data?.allSurveyTemplates) {
          setTemplates([...data.allSurveyTemplates]);
        }
      },
    }
  );

  useEffect(() => {
    runQueryGetTemplates();
  }, [renderList]);

  return (
    <GeneralContainer>
      {templates.map((record) => {
        return (
          <CategoryContainer>
            <label>{record?.templateName}</label>
            <Tooltip
              onClick={() =>
                handleOpen({
                  description: record?.templateName,
                  id: record?.idSurveyTemplate,
                  surveyId: record?.idSurvey,
                })
              }
              title="Open Template"
            >
              <OpenModal />
            </Tooltip>
          </CategoryContainer>
        );
      })}
      {loadingTemplates && <ModalLoader></ModalLoader>}
    </GeneralContainer>
  );
};

export default TemplateList;
